"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingEventRecorder = void 0;
class LoggingEventRecorder {
    record(event) {
        console.log(`Record Event [${String(event.fields.eventType)}]`, event);
    }
    async flush() {
        console.log("Flushing");
        return 0;
    }
}
exports.LoggingEventRecorder = LoggingEventRecorder;
